import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetLicenceTransferDetailsAsync,
  ILicenceTransferDetails,
} from "../../api/ILicenceTransfer";
import { RootState } from "../store";

export interface LicenceTransferState {
  fetchStatus: string;
  licenceTransfer?: ILicenceTransferDetails;
}

const initialState: LicenceTransferState = {
  fetchStatus: "Loading...",
  licenceTransfer: undefined,
};

export const loadLicenceTransferAsync = createAsyncThunk(
  "licenceTransfer/load",
  async (licenceTransferId: string) => {
    const response = await GetLicenceTransferDetailsAsync(licenceTransferId);
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const licenceTransferSlice = createSlice({
  name: "licenceTransfer",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadLicenceTransferAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadLicenceTransferAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.licenceTransfer = action.payload;
      });
  },
});

export const selectLicenceTransfer = (state: RootState) =>
  state.licenceTransfer;

export default licenceTransferSlice.reducer;
